<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col class="search-left" span="24">

          <label class="search-label">类型</label>
          <Select style="margin-left: 10px;" v-model="task_type" class="search-input" clearable @on-change="taskTypeChange">
            <Option
              v-for="item in types"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" style="margin-left: 10px;">执行人</label>
          <Select style="margin-left: 10px;" v-model="user" class="search-input" clearable @on-change="userChange">
            <Option
              v-for="item in userIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>


          <Button  @click="showAddModal" type="primary" style="margin-left: 50px;">添加</Button>

          <Button @click="handleDelete" type="error" style="margin-left: 50px;">删除</Button>

        </Col>
      </Row>

      <tables
        editable
        :columns="real_columns"
        v-model="tableData"
        :loading="tableLoading"
        @on-selection-change="changeId"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :mask-closable="false"
      :width="1000"
      v-model="addModal"
      title="创建任务"
      footer-hide
      >
      <forms :resetFlag="resetFlag"
        ref="createTask"  
       @on-ok="addSumit" @on-cancel="cancel"  />
    </Modal>

  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./add_task_form.vue";
import { getTaskList, createTask, getTaskTypeList, getLiveType, deleteTasks, getStrategyUser} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      types:[],
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      selectId:[],
      taskTypes:[],
      userIds:[],
      tableLoading: true,
      allMoney: 0.0,
      startTime: "",
      endTime: "",
      real_columns:[],
      task_type:'',
      user:'',
      columns: [
      {type: "selection",width: 60,align: "center", task_array: [2, 5, 4]},
        { title: "任务类型" , key: "task", task_array: [2, 5, 4] },
        { title: "搜索关键词" , key: "search", task_array: [5]},
        { title: "处理搜索结果" , key: "result_count", task_array: [5]},
        { title: "发表得什么评论" , key: "finish_result", task_array: [5]},
        { title: "是谁的视频" , key: "username", task_array: [4],
          render: (h, params) => {
            let texts = params.row.dyVideo.username;
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }},
          { title: "视频标题" , key: "video_title", task_array: [4],
          render: (h, params) => {
            let texts = params.row.dyVideo.video_title;
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }}, 
        { title: "视频链接" , key: "video_url", task_array: [4],render: (h, params) => {
              // 设置为<a>标签
                return h('a', {
                // 此处为歌曲地址的超链接样式设置（添加下划线）
                  style: {
                    textDecoration: 'underline'
                  },
                  attrs: {
                    href: params.row.dyVideo.video_url, target: '_blank'
                  }
                }, params.row.video_url)
              }},
        { title: "评论类型" , key: "video_url", task_array: [4],render: (h, params) => {
            let type_ = params.row.comment_type;
            let texts = ''
            if (type_ == 0){
              texts = "黑粉"
            }else if (type_ == 1){
              texts = "白粉"
            }else{
              texts = "其他"
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }},
        { title: "视频链接" , key: "video_url", task_array: [2],
        render: (h, params) => {
              // 设置为<a>标签
                return h('a', {
                // 此处为歌曲地址的超链接样式设置（添加下划线）
                  style: {
                    textDecoration: 'underline'
                  },
                  attrs: {
                    href: params.row.dyComment.video_url, target: '_blank'
                  }
                }, params.row.dyComment.video_url)
              }},
        
        {title: "被评论的视频标题",key: "type",render: (h, params) => {
              return h('div', [
              // 显示的位置上方
                h('Tooltip', {
                  props: { placement: 'top' ,transfer: true}
                }, [
                  h('span', {
                    style: {
                      display: 'inline-block',
                      width: '100px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  }, params.row.dyComment.video_title),
                  // 显示的内容
                  h('span', {
                    slot: 'content',
                    style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                  },params.row.dyComment.video_title)
                ])
              ])
            }, task_array: [2]
        }
        ,{
          title: "发表的是什么评论",
          key: "type",render: (h, params) => {
              return h('div', [
              // 显示的位置上方
                h('Tooltip', {
                  props: { placement: 'top' ,transfer: true}
                }, [
                  h('span', {
                    style: {
                      display: 'inline-block',
                      width: '100px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  }, params.row.dyComment.content),
                  // 显示的内容
                  h('span', {
                    slot: 'content',
                    style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                  },params.row.dyComment.content)
                ])
              ])
            }, task_array: [2]
        },{
          title: "评论的谁的视频",
          key: "type",
          render: (h, params) => {
            let texts = params.row.dyComment.username;
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }, task_array: [2]
        },{title: "是谁发表的评论",
          key: "type",
          render: (h, params) => {
            let texts = params.row.dyComment.dy_source_name;
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }, task_array: [2]
        },{ title: "该任务是谁在执行" , key: "dy_name", "task_array": [2, 4, 5] },
        {
          title: "任务状态",
          key: "type",
          render: (h, params) => {
            let texts = "";
            if (params.row.finish) {
              texts = "已完成";
            }else{
              texts = "未完成";
            }

            return h(
              "div",
              {
                props: {},
              },
              texts);
          }, "task_array": [2, 4, 5]
        },
        { title: "创建时间", key: "create_time", editable: true, task_array: [2, 4, 5]},
        { title: "任务完成时间" , key: "finish_time", editable: true, task_array: [2, 4, 5]},
        { title: "评论的内容" , key: "finish_result", task_array: [4]},
        { title: "任务结果" , key: "finish_result", task_array: [5]}
      ],
      tableData: [],
    };
  },
  methods: {
    getUsers(){
      getStrategyUser({}).then((res) => {
        var users = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          data[i] = { id: users[i].id.toString(), name: users[i].username }
      }
        this.userIds = data
      });
    }
    ,
    userChange(value){
      this.user = value
      this.handleSearch()
    },
    taskTypeChange(value){
      this.task_type = value
      this.real_columns = []
      for (var i = 0; i < this.columns.length; i++){
        var task_array = this.columns[i]['task_array']
        if (task_array.indexOf(parseInt(this.task_type)) !== -1){   // 包含这个值就添加表头
          this.real_columns.push(this.columns[i])
        }
      }
      this.handleSearch();
    },
    getTaskTypes(){
      getTaskTypeList().then((res) => {
        this.taskTypes = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < this.taskTypes.length; i++) {
          data[i] = { id: this.taskTypes[i].id.toString(), name: this.taskTypes[i].name }
        }
        this.types = data
        
        if (data.length != 0){
          this.task_type = data[0]['id']

        this.real_columns = []
        for (var i = 0; i < this.columns.length; i++){
          
          var task_array = this.columns[i]['task_array']
          if (task_array.indexOf(parseInt(this.task_type)) !== -1){   // 包含这个值就添加表头
            this.real_columns.push(this.columns[i])
          }
        }
          this.handleSearch();
        }

      });
    },
    showAddModal() {
      this.addModal = true;
      this.resetFlag = !this.resetFlag;
      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.createTask.setLiveType(liveTypes);
        this.$refs.createTask.setTaskType(this.taskTypes);
      });
    },
    addSumit(formValidate) {
      var comment_type = 0
      if (formValidate.comment_type == '黑粉'){
        comment_type = 0
      }else if (formValidate.comment_type == '白粉'){
        comment_type = 1
      }else{
        comment_type = 2
      }

      var ids = []
      var count = 1
      if (formValidate.user_type == '具体的人'){
        ids = formValidate.users
      }else{
        if (formValidate.user_number == '%20'){
          count = 0.2
        }else if (formValidate.user_number == '%50'){
          count = 0.5
        }else if (formValidate.user_number == '%80'){
          count = 0.8
        }
      }

      let data = {
        "comment_id": formValidate.comment,
        "task_id": formValidate.taskType,
        "search": formValidate.search,
        "result_count": formValidate.result_count,
        "video_id": formValidate.video,
        "comment_type": comment_type,
        "ids": ids,
        "count": count,
      }

      createTask(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        task_id:this.task_type,
        user: this.user
      };
      getTaskList(params).then((res) => {
        if (res.data.code == 200) {

          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    changeId(selection) {
      this.selectId = [];
      this.pieceCount = selection.length;
      for (let i = 0; i < selection.length; i++) {
        this.selectId[i] = selection[i].id;
      }
    },
    handleDelete(params) {
      if (this.selectId.length == 0) {
        this.$Message.warning("请选择任务");
        return;
      }

        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
              let data = new FormData();
              data.set('ids', this.selectId)
              deleteTasks(data)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.handleSearch()
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.getTaskTypes()
    this.getUsers()
  },
};
</script>
